<template>
  <div>
    <el-dialog title="Оформить размещение на канале" :visible.sync="modal" width="30%">
      <div class="overlay" v-if="loading">
        <br><br><br><br><br>
        <div class="el-loading-spinner mt-5 mb-5">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg>
        </div>
        <br><br><br><br><br><br><br>
      </div>
      <div v-else>
        <div v-if="step === 1">
          <div class="mb-2 mt-3 block" v-if="creatives.length">
            <label>Доступные креативы:</label>
            <creativeCarousel :selected="form.creative_id" :creatives="creatives"
                              @onSelectCreative="onSelectCreative"></creativeCarousel>
          </div>
          <el-button @click="step++" type="primary" class="btn-block">Далее</el-button>
        </div>
        <div v-else>
          <h5>Список площадок для публикации</h5>
          <div style="display: flex; gap: 5px; margin-bottom: 25px; flex-direction: column;">
            <div v-for="platform in form.platforms" :key="platform.id" style="display: flex; gap: 10px; margin-bottom: 5px">
              <el-select v-model="platform.platform_id" :multiple="false" placeholder="Площадки для публикации">
                <el-option v-for="item in platforms" :key="item.id" :label="item.name"
                           :value="item.id">
                  {{ item.name }}
                </el-option>
              </el-select>
              <el-date-picker style="width: 200px" :picker-options="datePickerOptions" type="datetime" v-model="platform.date"
                              format="dd.MM.yyyy HH:mm" value-format="dd.MM.yyyy HH:mm"
                              placeholder="День выхода поста"></el-date-picker>
              <div>
                <el-button @click="removePlatform(platform.id)" type="danger" icon="el-icon-delete" plain></el-button>
              </div>
            </div>
            <div v-if="!form.platforms.length" style="display: flex; justify-content: center; padding: 10px;background: #f6f6f6;">
              Список площадок пуст
            </div>
            <div>
              <el-button @click="addPlatform()" type="primary" plain>Добавить</el-button>
              <el-button @click="selectAll" plain>Добавить все</el-button>
              <el-button @click="form.platforms = []" plain>Очистить</el-button>
            </div>
          </div>
          <div class="form-group mb-5">
            <label class="btn-block">Время для публикации поста</label>
            <el-radio v-model="form.time_type" :label="1">24 ч.</el-radio>
            <el-radio v-model="form.time_type" :label="2">48 ч.</el-radio>
          </div>
          <el-button type="primary" @click="createOrder" class="btn-block">Разместить запись</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import creativeCarousel from '../acceptRequest/creativeCarousel';
import moment from "moment";

export default {
  name: "MarketOrderModal",
  data() {
    return {
      modal: false,
      step: 1,
      datePickerOptions: {
        disabledDate(date) {
          let day = 1000 * 60 * 60 * 24;
          return date <= new Date() - day;
        },
        firstDayOfWeek: 1,
      },
      platforms: [],
      creatives: [],
      form: {
        platforms: []
      },
      item: {},
      loading: false
    }
  },
  computed: {
    availablePlatforms() {
      const alreadyUsedIds = this.form.platforms.map((item) => item.platform_id)
      return this.platforms.filter((item) => !alreadyUsedIds.includes(item.id))
    }
  },
  methods: {
    onSelectCreative(id) {
      this.form.creative_id = id;
    },
    getTaskCreatives() {
      this.loading = 1;
      this.$store.dispatch('publisher/getTaskCreatives', {
        id: this.item.id
      }).then((response) => {
        this.creatives = response.data.data;
        this.creatives[0].id = 0;
      }).finally(() => {
        this.loading = 0;
      });
    },
    getPlatformsList() {
      this.loading = 1;
      this.$store.dispatch('publisher/getAllPlatforms', {
        active: true
      }).then((response) => {
        this.loading = 0;
        this.platforms = response.data.data;
      });
    },
    createOrder() {
      this.$store.commit('setLoader', 1);
      this.$store.dispatch('publisher/createMarketOrder', this.form).then((response) => {
        this.$store.commit('setLoader', 0);
        if (response.data.status === 'error') {
          this.$notify.error({
            title: 'Ошибка',
            message: response.data.error
          });
        } else if (response.data.status === 'ok') {
          this.$notify.success({
            title: 'Заявка',
            message: 'Успешно создано и скоро будет опубликовано'
          });
          this.modal = false;
        }
      });
    },
    pad(n) {
      return n < 10 ? '0' + n : n
    },
    addPlatform(platformId = null) {
      this.form.platforms.push({
        id: crypto.randomUUID(),
        platform_id: platformId,
        date: moment().add(5, 'minute').add(this.form.platforms.length + 1, 'minutes').format('DD.MM.YYYY HH:mm')
      })
    },
    selectAll() {
      const platforms = [...this.availablePlatforms]
      this.form.platforms = []
      for (const platform of platforms) {
        this.addPlatform(platform.id)
      }
    },
    removePlatform(id) {
      this.form.platforms.splice(this.form.platforms.findIndex((item) => item.id === id), 1)
    },
    startOrder(item) {
      let date = new Date(new Date().getTime() + 5 * 60000);

      this.step = 1;
      this.form = {
        platforms: [
          {
            id: crypto.randomUUID(),
            platform_id: null,
            date: this.pad(date.getDate()) + '.' + this.pad(date.getUTCMonth() + 1) + '.' + date.getUTCFullYear() + ' ' + date.toLocaleTimeString(),
          }
        ],
        id: item.id,
        creative_id: 0,
        time_type: 1,
      };
      this.modal = true;
      this.item = item;
      this.getTaskCreatives();
      this.getPlatformsList();
    }
  },
  components: {
    creativeCarousel
  }
}
</script>

<style scoped>

</style>
